<template>
    <div class="page-table haberTanim mainDiv listPage" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">Partner Listesi</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-col :lg="18" :md="18" :sm="24" :xs="24">
                <div>
                    <el-radio-group size="mini" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                    text-color="gray">
                        <el-radio-button label="1">
                            <i class="mdi mdi-account-group mdi-24px" style="color: #13ce66; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="selectIcon==='1'">Yayındaki Partnerler</label>
                            </transition>
                        </el-radio-button>
                        <el-radio-button label="0">
                            <i class="mdi mdi-account-group mdi-24px" style="color: #ec205f; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="selectIcon==='0'">Taslak Partnerler</label>
                            </transition>
                        </el-radio-button>
                    </el-radio-group>
                </div>
            </el-col>
            <el-col :lg="6" :md="6" :sm="24" :xs="24">
                <div class="flex">
                    <div class="daireclass2 margin-left-10"></div><div class="margin-left-5">Partner Düzenle</div>
                    <div v-if="selectIcon==='1'" class="daireclass3 margin-left-10"></div><div v-if="selectIcon==='1'" class="margin-left-5">Yayından Kaldır</div>
                    <div v-if="selectIcon==='0'" class="daireclass4 margin-left-10"></div><div v-if="selectIcon==='0'" class="margin-left-5">Yayına Al</div>
                </div>
                <el-tooltip :content='$t("src.views.apps.haberler.tanimlama.title")'
                            :open-delay="500"
                            placement="bottom">
                    <el-button
                            v-on:click="routePartner('Partner Tanımla')"
                            style="float: right; margin-top: -25px"
                            size="mini"
                            icon="el-icon-plus">
                    </el-button>
                </el-tooltip>
            </el-col>
            <el-table
                    :data="partnerList.filter(data => !search.partnerAdi || data.baslik.toLowerCase().includes(search.partnerAdi.toLowerCase()) )"
                    ref="filterTable"
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        label="Resim"
                        width="auto">
                    <template slot-scope="scope">
                        <el-popover
                                transition="el-fade-in-linear"
                                placement="left"
                                width="auto"
                                trigger="hover">
                            <img v-if="scope.row.logo" :src="imagepath+scope.row.logo"
                                 :alt="scope.row.partnerAdi">
                            <i style="font-size: 24px; cursor: pointer; color: #337ab7" slot="reference"
                               class="el-icon-picture"></i>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="partnerAdi"
                        label="Partner"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="telefon"
                        label="Telefon"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="Website"
                        width="auto">
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.webSite" target="_blank" :underline="false" :href="scope.row.webSite" >{{scope.row.webSite}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot="header" slot-scope="scope">
                        <input
                                class="searchClass"
                                v-model="search.partnerAdi"
                                @input="forceUpper($event, search, 'partnerAdi')"
                                size="mini"
                                placeholder="Ara"/>
                    </template>
                    <template slot-scope="scope">
                        <el-tooltip :content='$t("src.views.apps.partner.liste.partnerduzenle")'
                                    :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-on:click="routePartner('Partner Düzenle',scope.row)"
                                    type="text"
                                    class="buttonEdit"
                                    icon="el-icon-edit">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.haberler.liste.yayindanKaldir")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon==='1'"
                                    @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    size="mini"
                                    class="buttonDel"
                                    type="text"
                                    icon="mdi mdi-pause mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip content='Yayına Al' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon==='0'"
                                    type="text"
                                    @click="partnerDurumChanges(scope.row,scope.$index,partnerList,1)"
                                    icon="mdi mdi-play mdi-24px">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>"{{selection.partnerAdi}}" partnerini yayından kaldırmak istiyor musunuz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="partnerDurumChanges(selection,selectionIndex,partnerList,0), deleteDialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="deleteDialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import partnerService from '../../../WSProvider/PartnerService'
    import notification from '../../../notification'
    import functions from '../../../functions'
    var moment = require('moment');

    export default {
        name: "PartnerListe",
        mounted() {
            this.getPartnerList();
        },
        data() {
            return {
                selectIcon: '1',
                radio: '1',
                path: partnerService.path,
                search: {
                    partnerAdi: ''
                },
                imagepath: partnerService.imageUrlKucuk,
                index: '',
                deleteDialogVisible: false,
                selection: '',
                selectionIndex: '',
                partnerList: [],
            }
        },
        methods: {
            handleChange(event) {
                this.selectIcon = event;
                this.getPartnerList();
            },
            forceUpper(e, o, prop) {
                const start = e.target.selectionStart;
                e.target.value = e.target.value.toUpperCase();
                this.$set(o, prop, e.target.value);
                e.target.setSelectionRange(start, start);
            },
            filterTag(value, row) {
                return row.il === value;
            },
            getPartnerList() {
                let self = this;
                partnerService.partnerList(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            e.olusumTarihi = moment(e.olusumTarihi).format('DD-MM-YYYY HH:mm:ss');
                        });
                        self.partnerList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });

            },
            routePartner(name, scope) {
                var tabList = this.$store.state.tabList;
                if (scope) {
                    this.$store.commit('changeUpdateKodu', scope.partnerId);
                }
                var header = functions.linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
            partnerDurumChanges(selection, index, list, durum) {
                partnerService.partnerDurumGuncelle(selection.partnerId, durum).then((response) => {
                    if (response.status === 200) {
                        switch (durum) {
                            case 0:
                                notification.Status("success", this, "Partner Taslağa Taşındı.");
                                list.splice(index, 1);
                                break;
                            case 1:
                                notification.Status("success", this, "Partner Yayına Alındı.");
                                list.splice(index, 1);
                                break;
                            case 2:
                                notification.Status("success", this, "Partner Arşive Taşındı.");
                                list.splice(index, 1);
                                break;
                        }

                    }
                })
            },
        }
    }

</script>


<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .el-radio-button--mini .el-radio-button__inner label {
        position: relative;
        bottom: 5px;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }

</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }


    @media (min-width: 768px) {
        .el-radio-button--mini .el-radio-button__inner {
            padding: 0 10px !important;
            font-size: 11px;
            border-radius: 0;
        }
    }


    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>